import { useStoreActions } from "../../../store/store-context";
import { useMutationState } from "../useMutationState";
import { pathgen } from 'object-path-generator';
export const useArchiveDraftTestIds = pathgen('useArchiveDraftTestIds');
export const useArchiveDraft = function useArchiveDraft() {
  let {
    onSuccess: _onSuccess,
    withPageLoader,
    biCode
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    api
  } = useStoreActions();
  const {
    mutate,
    isLoading
  } = useMutationState({
    mutationFn: draftId => api.draft.archive(draftId),
    withPageLoader,
    biCode,
    mutationName: 'archive-draft',
    toasts: {
      successMessage: 'Draft archived successfully',
      successTestId: useArchiveDraftTestIds.SuccessToast(),
      errorMessage: 'Failed to archive draft',
      errorTestId: useArchiveDraftTestIds.ErrorToast()
    },
    onSuccess: () => {
      _onSuccess === null || _onSuccess === void 0 || _onSuccess();
    }
  });
  return {
    archive: mutate,
    isLoading
  };
};